import styled from '@emotion/styled'
import colors from '../colors'

export const TextUnimportant = styled.small`
	font-size: 14px;
	color: ${colors.heather};
`
